
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point } from "../../../domain/drawing";

@Component
export default class MouseTrackableMixin extends Mixins() {
  @Prop({ default: 1 })
  scale: number;

  data(): any {
    return {
      isMouseTracking: false,
      mouseLocation: null as Point,
      isMouseLeftButtonPressed: false,
      isMouseRightButtonPressed: false,
    };
  }
  isMouseTracking: boolean;
  mouseLocation: Point;
  isMouseLeftButtonPressed: boolean;
  isMouseRightButtonPressed: boolean;

  onMouseEntered(container: Element, e: PointerEvent): void {
    this.isMouseTracking = true;
    this.track(container, e);
  }

  onMouseMoved(container: Element, e: PointerEvent): void {
    this.track(container, e);
  }

  onMouseLeaved(container: Element, e: PointerEvent): void {
    this.track(container, e);
    this.isMouseTracking = false;
  }

  onMousePressed(container: Element, e: PointerEvent): void {
    this.track(container, e);
  }

  onMouseReleased(container: Element, e: PointerEvent): void {
    this.track(container, e);
  }

  private track(container: Element, e: PointerEvent): void {
    this.mouseLocation = this.toClientLocation(container, e);
    this.isMouseLeftButtonPressed = !!(e.buttons & 0x1);
    this.isMouseRightButtonPressed = !!(e.buttons & 0x2);
  }

  toClientLocation(container: Element, e: PointerEvent): Point {
    const rootRect = container.getBoundingClientRect();
    return new Point(
      e.clientX - rootRect.left,
      e.clientY - rootRect.top
    ).multiply(1 / this.scale);
  }
}
